import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Figma Component property - Definition */
export class DocsBlockFigmaComponentPropertyDefinition extends DocsBlockPropertyDefinition {
}
